import React from 'react';

/**
 * Global color mode context used for MUI theme switching.
 * Keeps the current mode ('light' | 'dark') and exposes toggle/setMode.
 */
export const ColorModeContext = React.createContext({
  mode: 'light',
  toggle: () => {},
  setMode: (_mode) => {},
});

export function useColorMode() {
  return React.useContext(ColorModeContext);
}
